module.exports = __webpack_public_path__ + "static/media/world-map5.83bccb2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/world-map5.svg
// module id = 183
// module chunks = 0